import { AxiosResponse } from "axios";
import { endPoints } from "utils/constants";
import { crudService } from "services/crud.service";
import { NotificationManager } from "react-notifications";
import {
  defaultMetaObj,
  deleteErrorResponse,
  deleteErrorResponsePhase,
  initialProjectState,
  projectDeleteErrorModified,
  projectDeleteErrorModifiedPhase,
} from "store/constants";
import { getErrorMessage, getPaginatedUrlWithSearchParams } from "store/helper";
import { createAsyncThunk, PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  getProjectsTeamAssignee,
  getProjectsUserAssignee,
} from "utils/helpers";

const { projectEndPoint } = endPoints;

export const fetchAllProjects = createAsyncThunk(
  "projects/fetchAllProjects",
  async (
    {
      page,
      limit,
      searchParamsObj = {},
    }: { page: number; limit?: number; searchParamsObj?: {} },
    { rejectWithValue }
  ) => {
    const paginatedUrl = getPaginatedUrlWithSearchParams({
      pageNumber: page,
      limit,
      endpoint: projectEndPoint,
      searchParams: { ...searchParamsObj },
    });
    try {
      const response: AxiosResponse = await crudService.getAll(paginatedUrl);

      // let result = await response.data.objects.map(async (item: any) => {
      //   const userAssignee = await getProjectsUserAssignee({
      //     id: item?.project_id,
      //   });

      //   const teamAssignee = await getProjectsTeamAssignee({
      //     id: item?.project_id,
      //   });

      //   return {
      //     ...item,
      //     assigned_team: teamAssignee?.objects || [],
      //     assigned_user: userAssignee?.objects || [],
      //   };
      // });

      // return {
      //   ...response?.data,
      //   result: (await Promise.all(result)) || [],
      // };

      return response?.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

export const addProject = createAsyncThunk(
  "projects/addProjects",
  async (newProject: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse = await crudService.create(
        `${projectEndPoint}/`,
        newProject
      );

      if (response.status === 201) {
        NotificationManager.success("Project Created Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteProject = createAsyncThunk(
  "projects/deleteProject",
  async ({ projectId }: any, { rejectWithValue }) => {
    try {
      const response: any = await crudService.delete(
        projectEndPoint,
        projectId
      );

      if (response.status === 204) {
        NotificationManager.success("Project Deleted Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      let errorModified = errorMessage;

      if (errorMessage?.includes(deleteErrorResponse)) {
        errorModified = projectDeleteErrorModified;
      }

      if (errorMessage?.includes(deleteErrorResponsePhase)) {
        errorModified = projectDeleteErrorModifiedPhase;
      }

      NotificationManager.error(errorModified);
      return rejectWithValue(error.message);
    }
  }
);

export const updateProject = createAsyncThunk(
  "projects/updateProject",
  async ({ updatedProject, projectId }: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse = await crudService.update(
        projectEndPoint,
        projectId,
        updatedProject
      );
      if (response.status === 204) {
        NotificationManager.success("Project updated Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

const projectSlice = createSlice({
  name: "projects",
  initialState: initialProjectState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch all projects
    builder
      .addCase(fetchAllProjects.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        fetchAllProjects.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.projects = action.payload.objects;
          state.meta = action.payload?.meta;
        }
      )
      .addCase(
        fetchAllProjects.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
          state.projects = [];
          state.meta = defaultMetaObj;
        }
      );

    // add project
    builder
      .addCase(addProject.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(addProject.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
      })
      .addCase(addProject.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // delete Project
    builder
      .addCase(deleteProject.pending, (State) => {
        State.loading = true;
      })
      .addCase(deleteProject.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
      })
      .addCase(
        deleteProject.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );

    //   update Project
    builder
      .addCase(updateProject.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        updateProject.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
        }
      )
      .addCase(
        updateProject.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );
  },
});

export const projectReducer = projectSlice.reducer;
